import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetM3uKeywordsQuery, useLazyGetM3uKeywordsQuery } from '../../redux/apis/linkManagement/m3u/lmM3uKeywordsApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateM3uKeyword from '../../components/M3u/EditCreateM3uKeyword'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import CustomersDropdown from '../../components/CustomersDropdown'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const M3uKeywords = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetM3uKeywordsQuery({
    expand: ['last_updated_by', 'customer'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },

    {
      title: 'CUSTOMER',
      dataIndex: 'customer',
      key: 'customer.customer_name',
      filter: true,
      filterComponent: CustomersDropdown,
      render: text => <div>{text?.customer_name}</div>
    },

    {
      title: 'M3U KEYWORD',
      dataIndex: 'm3u_keyword',
      key: 'm3u_keyword',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'KEYWORD STATUS',
      dataIndex: 'keyword_status',
      key: 'keyword_status',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false }
      ],
      render: text => <div>{text ? 'Active' : 'Inactive'}</div>
    },

    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    },
    {
      title: 'CREATED AT',
      dataIndex: 'created_at',
      key: 'created_at',

    },
    {
      title: 'UPDATED AT',
      dataIndex: 'updated_at',
      key: 'updated_at',

    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_m3ukeywords') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_m3ukeywords') && create && (
        <EditCreateM3uKeyword
          state='create'
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {can('change_m3ukeywords') && edit && (
        <EditCreateM3uKeyword
          state='edit'
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetM3uKeywordsQuery}
            fileName='m3ukeywords'
          />
          {can('add_m3ukeywords') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New Keyword
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default M3uKeywords
